import { useStaticQuery, graphql } from "gatsby"

const useTeam = () => {
  const { nzTeam, auTeam } = useStaticQuery(graphql`
    query TeamArchive {
      auTeam: allWpTeam(
        sort: {menuOrder: ASC}
        filter: { 
          categories: { 
            nodes: { 
              elemMatch: { slug: { ne: "marketing-author" } } 
            } 
          },
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "australia" } } 
            }
          } 
        }
      )
      {
        nodes {
          ...TeamCard
        }
      }
      nzTeam: allWpTeam(
        sort: {menuOrder: ASC}
        filter: { 
          categories: { 
            nodes: { 
              elemMatch: { slug: { ne: "marketing-author" } } 
            } 
          },
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "new-zealand" } } 
            }
          } 
        }
      )
      {
        nodes {
          ...TeamCard
        }
      }
    }
  `)

  return process.env.GATSBY_WP_CATEGORY_SITE_SLUG === 'new-zealand' ? nzTeam.nodes : auTeam.nodes
}

export default useTeam